import { useTranslation } from "react-i18next";
import { useState } from "react";
import { connect } from "react-redux";
import {
    Tab,
    TabList,
    TabValue,
    makeStyles,
    tokens,
    Field,
    Card,
    Text
} from "@fluentui/react-components";

// functions 
import * as ownFunctions from './Proyection.General.Functions';

// components
import { PageHeader } from "../../commons/component/PageHeader/PageHeader";
import ProtocolSelectorComponent from "../../commons/component/Inputs/ProtocolSelector/ProtocolSelectorComponent";
import ProyectionComponent from "../../components/Protocols/Proyection/Proyection.component";
import ProyectionDataGridComponent from "../../components/Protocols/Proyection/ProyectionDataGrid.Component";
import StatisticsDashboardComponent from "../../components/Proyections/Statistics/StatisticsDashboard.Component";
import { Protocol } from "../../models/Entities/Protocols/Protocol";
import ProfitChartComponent from "../../components/Protocols/ProfitChart/ProfitChar.Component";
import { Separator } from "@fluentui/react";

const useStyles = makeStyles({
    container: {
        display: 'flex',
        flexDirection: 'column',
        gap: tokens.spacingVerticalL,
        padding: tokens.spacingVerticalL
    },
    selectorCard: {
        padding: tokens.spacingVerticalM
    },
    tabsContainer: {
        display: 'flex',
        flexDirection: 'column',
        gap: tokens.spacingVerticalM
    },
    emptyState: {
        textAlign: 'center',
        padding: tokens.spacingVerticalXXL,
        color: tokens.colorNeutralForeground3
    }
});

const ProyectionGeneralPage = (props: ownFunctions.Props) => {

    const [t] = useTranslation();
    const styles = useStyles();

    const [selectedProtocols, setSelectedProtocols] = useState<Protocol[]>([]);
    const [selectedTab, setSelectedTab] = useState<TabValue>('statistics');

    const onProtocolChange = (protocols: Protocol[] | undefined) => {
        setSelectedProtocols(protocols || []);
    };

    const onTabSelect = (event: any, data: any) => {
        setSelectedTab(data.value);
    };

    return (
        <>
            <PageHeader title={t('proyectionsPage.title')} />
            <div className={styles.container}>
                <div className="Section">
                    {process.env.REACT_APP_PREVIEW_FEATURES === 'true' && <ProfitChartComponent />}
                    {/* <Separator />
                    <Card className={styles.selectorCard}>
                        <Field label={t('proyectionsPage.selectProtocol') || 'Seleccionar Protocolo'}>
                            <ProtocolSelectorComponent
                                onChangeSelection={onProtocolChange}
                                selectionLimit={0}
                            />
                        </Field>
                    </Card> */}

                    {/* {selectedProtocols.length > 0 ? (
                        <div className={styles.tabsContainer}>
                            <TabList selectedValue={selectedTab} onTabSelect={onTabSelect}>
                                <Tab value="statistics">{t('proyectionsPage.tabs.statistics') || 'Panel Estadístico'}</Tab>
                                <Tab value="charts">{t('proyectionsPage.tabs.charts') || 'Gráficos'}</Tab>
                                <Tab value="table">{t('proyectionsPage.tabs.table') || 'Tabla'}</Tab>
                            </TabList>

                            {selectedTab === 'statistics' && (
                                <StatisticsDashboardComponent protocolId={selectedProtocols[0]?.id} />
                            )}

                            {selectedTab === 'charts' && (
                                <ProyectionComponent
                                    protocolIds={selectedProtocols.map(p => p.id).filter((id): id is number => id !== undefined)}
                                    revenueIsQuarterly={true}
                                    revenueMonthIndexInQuarter={2}
                                    showMonthlyNetLine={true}
                                    showMarginLine={true}
                                    showMinMarginLine={true}
                                    titleBars="Ingresos vs Costos"
                                    titleFlow="Flujo de Caja Acumulado"
                                    costLabel="Costos Totales"
                                    revenueLabel="Ingresos"
                                    netLabel="Neto Mensual"
                                    cumulativeLabel="Saldo Acumulado"
                                    marginLabel="Margen %"
                                    minMarginLabel="Margen Mínimo 35%"
                                />
                            )}

                            {selectedTab === 'table' && (
                                <ProyectionDataGridComponent
                                    monthlyRevenue={[0, 0, 60000, 0, 0, 60000, 0, 0, 60000, 0, 0, 60000]}
                                    revenueLabel={t('income')}
                                    providerCostLabel={t('providerCosts')}
                                    medicalTeamCostLabel={t('medicalTeamCosts')}
                                    netLabel={t('net')}
                                    cumulativeLabel={t('cumulative')}
                                    marginLabel={t('marginPercent')}
                                    showCostsSplit={true}
                                    showMargin={true}
                                    showNet={true}
                                    showCumulativeMinProfitLine={true}
                                    enableExport={true}
                                />
                            )}
                        </div>
                    ) : (
                        <Card>
                            <div className={styles.emptyState}>
                                <Text size={500}>{t('proyectionsPage.selectProtocolPrompt') || 'Seleccione un protocolo para ver las proyecciones financieras'}</Text>
                            </div>
                        </Card>
                    )} */}
                </div>
            </div>
        </>
    )
}

export default connect(
    ownFunctions.mapStateToProps,
    ownFunctions.mapDispatchToProps
)(
    ProyectionGeneralPage as any
)
